import { Col, Modal, Row } from "react-bootstrap";

import { PatientVisit } from "../../amplify/appsync/search-patients";
import { useEffect, useState } from "react";
import { callFhirReasonsForVisit } from "../../amplify/appsync/fetch-sync-fhir";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

export const ReasonsForVisitModal = (props: {
    showModal: boolean,
    setShowModal: any,
    patientVisit: PatientVisit,
}) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [reasons, setReasons] = useState<string>();

    useEffect(() => {
        if (props.showModal && props.patientVisit && props.patientVisit.fhir_id) {
            setIsLoading(true);
            callFhirReasonsForVisit({
                csn: props.patientVisit.csn,
                fhir_id: props.patientVisit.fhir_id,
            }).then((output: any) => {
                setReasons(JSON.stringify(output));
            }).finally(() => {
                setIsLoading(false);
            });
        }
    }, [props.showModal]);

    const handleClose = () => {
        props.setShowModal(false);
    };

    return (
        <Modal show={props.showModal} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{props.patientVisit.chief_complaint}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    isLoading && (
                        <Row>
                            <Col>
                                <FontAwesomeIcon icon={faSpinner} spin /> Loading...
                            </Col>
                        </Row>
                    )
                }
                {
                    reasons
                }
            </Modal.Body>
        </Modal>
    );
};
